module.exports = __webpack_public_path__ + "img/background-image.e36ba599.png";